var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypcnUser4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.50001C14.1667 6.34918 13.7 5.30751 12.9467 4.55418C12.1925 3.80001 11.1508 3.33334 10 3.33334C8.84917 3.33334 7.8075 3.80001 7.05333 4.55418C6.3 5.30751 5.83333 6.34918 5.83333 7.50001C5.83333 8.65084 6.3 9.69251 7.05333 10.4458C7.8075 11.2 8.84917 11.6667 10 11.6667C11.1508 11.6667 12.1925 11.2 12.9467 10.4458C13.334 10.0594 13.6412 9.6002 13.8506 9.09466C14.06 8.58912 14.1674 8.04719 14.1667 7.50001ZM5 15.8333C5 16.6667 6.875 17.5 10 17.5C12.9317 17.5 15 16.6667 15 15.8333C15 14.1667 13.0383 12.5 10 12.5C6.875 12.5 5 14.1667 5 15.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnUser4);
export default __webpack_public_path__ + "static/media/typcn_user (4).98680a945453b2cf7abc934b96dab7e2.svg";
export { ForwardRef as ReactComponent };